import React from "react";
import { Container } from "reactstrap";
const Header = (props) => {
    return (
        <>
            <div className="header bg-gradient-default pb-5 pt-5 pt-md-8">
                <Container fluid className={ props.children ? "mt--3 mb-4" : ""}>
                    <div className="header-body">
                        {props.children}
                    </div>
                </Container>
            </div>
        </>
    );
};

export default Header;
